import React from 'react';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleXmarkSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircleXmark} {...props} />;
}
